import axios from '@/plugins/axios';
import evaluateErrorReturn from '@/utils/errors/evaluateErrorReturn';
import { snackBarError, snackBarSuccess } from '@/utils/snackbar';

/**
 * Set form data place
 * @private
 * @param {Object} data
 * @return {FormData} payload
 */
const _setFormData = data => {
	const formData = new FormData();
	formData.append('_id', data._id);
	formData.append('typeDocuments', JSON.stringify(data.typeDocuments));
	formData.append('documents', data.documents);
	return formData;
};

export default {
	async eliminarTemporalOT({ commit, dispatch }, { idPlace, idot }) {
		try {
			commit('setLoading', true);
			await axios(`/place/${idPlace}/delete-temporal-ot/${idot}`, {
				method: 'delete',
			});
			snackBarSuccess('OT Temporal eliminada');
			await dispatch('Lodging/fetchPlace', null, { root: true });
		} catch (e) {
			snackBarError(e)(commit);
		} finally {
			commit('setLoading', false);
		}
	},
	async setTypeDocument({ commit, dispatch }, payload) {
		try {
			const { data } = await axios(`/place/${payload._id}/typeDocuments`, {
				method: 'put',
				data: payload.typeDocuments,
			});
			await dispatch('Lodging/fetchPlace', null, { root: true });
			snackBarSuccess(data.message)(commit);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async fetchPlace({ commit }) {
		try {
			const { data } = await axios('/place', { method: 'get' });
			commit('setPlaces', data.place);
			commit('Lodging/setPlaces', data.place, { root: true });
		} catch (e) {
			commit('setPlaces', []);
			snackBarError(e)(commit);
		}
	},
	async fetchPlacesByIdUser({ commit }, user) {
		try {
			const { data } = await axios(`/place/${user}`, { method: 'get' });
			commit('setPlacesUser', data.place);
		} catch (e) {
			commit('setPlacesUser', []);
			snackBarError(e)(commit);
		}
	},
	async createPlace({ commit }, place) {
		try {
			commit('setLoading', true);
			const { data } = await axios(`/place`, { method: 'post', data: place });
			snackBarSuccess('Establecimiento creado')(commit);
			commit('addPlace', data.places);
		} catch (e) {
			snackBarError(e)(commit);
		} finally {
			commit('setLoading', false);
		}
	},
	async deletePlace({ commit }, id) {
		try {
			commit('setLoading', true);
			const { data } = await axios(`/place/one/${id}`, { method: 'delete' });
			snackBarSuccess('Establecimiento eliminado');
			commit('removePlace', data.place._id);
		} catch (e) {
			snackBarError(e)(commit);
		} finally {
			commit('setLoading', false);
		}
	},
	async createService({ commit, dispatch }, { payload, placeId }) {
		try {
			commit('setLoading', true);
			await axios(`/place/${placeId}/service`, {
				method: 'post',
				data: payload,
			});
			await dispatch('Lodging/fetchPlace', null, { root: true });
			snackBarSuccess('Servicio creado')(commit);
		} catch (e) {
			snackBarError(e)(commit);
		} finally {
			commit('setLoading', false);
		}
	},
	async updateService({ commit, dispatch }, { payload, placeId }) {
		try {
			commit('setLoading', true);
			const serviceId = payload._id;
			await axios(`/place/${placeId}/service/${serviceId}`, {
				method: 'put',
				data: payload,
			});
			snackBarSuccess('Servicio actualizado')(commit);
			await dispatch('Lodging/fetchPlace', null, { root: true });
		} catch (e) {
			snackBarError(e)(commit);
		} finally {
			commit('setLoading', false);
		}
	},
	async updatePlace({ commit, dispatch }, { payload, placeId }) {
		try {
			await axios(`/place/${placeId}`, {
				method: 'put',
				data: payload,
			});
			await dispatch('Lodging/fetchPlace', null, { root: true });
			snackBarSuccess('Establecimiento actualizado')(commit);
		} catch (e) {
			snackBarError(e)(commit);
		}
	},
	async deleteService({ commit, dispatch }, { serviceId, placeId }) {
		try {
			commit('setLoading', true);
			await axios(`/place/${placeId}/service/${serviceId}`, {
				method: 'delete',
			});
			snackBarSuccess('Servicio eliminado')(commit);
			await dispatch('Lodging/fetchPlace', null, { root: true });
		} catch (e) {
			snackBarError(e)(commit);
		} finally {
			commit('setLoading', false);
		}
	},
	async deleteDocument({ commit, dispatch }, { idPlace, indexDoc }) {
		try {
			await axios(`/place/${idPlace}/documents/${indexDoc}`, {
				method: 'patch',
			});
			await dispatch('Lodging/fetchPlace', null, { root: true });
			snackBarSuccess('Documento eliminado')(commit);
		} catch (e) {
			snackBarError(e)(commit);
		}
	},
	async pathGeofence({ commit, dispatch }, { payload, id }) {
		try {
			const { data } = await axios(`/place/${id}/geofence`, {
				method: 'patch',
				data: payload,
			});
			await dispatch('Lodging/fetchPlace', null, { root: true });
			snackBarSuccess(data.message)(commit);
		} catch (e) {
			snackBarError(e)(commit);
		}
	},
	async unlinkSharedPlace({ commit }, id) {
		try {
			commit('setLoading', true);
			await axios(`/place/${id}/actions/unlink-share`, { method: 'patch' });
			commit(
				'Snackbar/showMessage',
				{
					content: 'Establecimiento compartido desvinculado',
					color: 'success',
				},
				{ root: true }
			);
			commit('removePlace', id);
		} catch (error) {
			commit(
				'Snackbar/showMessage',
				{
					content: evaluateErrorReturn(error),
					color: 'error',
				},
				{ root: true }
			);
		} finally {
			commit('setLoading', false);
		}
	},
	async deletePersonFromExcludedRecipients(
		{ commit },
		{ placeId, notificationConfigId, personId }
	) {
		try {
			const { data } = await axios(
				`/place/${placeId}/notification-config/${notificationConfigId}/excludedPerson/${personId}`,
				{
					method: 'delete',
				}
			);
			snackBarSuccess(data.message);
			commit('setSelectedNotificationConfig', data.notificationConfig);
			commit('updateNotificationConfigs', data.notificationConfig);
		} catch (e) {
			snackBarError(e)(commit);
		}
	},
	async upload({ commit, dispatch }, payload) {
		try {
			const { data } = await axios(`/place/${payload._id}/upload`, {
				method: 'put',
				data: _setFormData(payload),
			});
			await dispatch('Lodging/fetchPlace', null, { root: true });
			snackBarSuccess(data.message)(commit);
		} catch (error) {
			snackBarError(error)(commit);
		}
	},
	async generatePdfReport(store, places) {
		const { data } = await axios(`/place/reports-pdf`, {
			method: 'post',
			data: { places },
			responseType: 'arraybuffer',
		});
		return data;
	},
	async generateOtPdfReport(store, orders) {
		const { data } = await axios(`/place/ot-report-pdf`, {
			method: 'post',
			data: { orders },
			responseType: 'arraybuffer',
		});
		return data;
	},
};
